import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#32a88f',
      main: '#0b8a6e',
      dark: '#076b55',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ede7f6',
      main: '#673ab7',
      dark: '#5e35b1',
      contrastText: '#fff',
    },
    success: {
      light: '#32a88f',
      main: '#0B8A6E',
      dark: '#0B8A6E',
    },
    error: {
      light: '#ef9a9a',
      main: '#f44336',
      dark: '#c62828',
    },
    warning: {
      light: '#fff8e1',
      main: '#ffe57f',
      dark: '#ffc107',
    },
  },
  typography: {
    fontFamily: ['Neue Montreal', 'Be Vietnam Pro', 'sans-serif'].join(','),
    h1: { fontFamily: 'Tungsten, sans-serif' },
    h2: { fontFamily: 'Tungsten, sans-serif' },
    h3: { fontFamily: 'Tungsten, sans-serif' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', borderRadius: 8, fontWeight: 600 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
      },
    },
  },
});

export default theme;
